import { usePagination } from "@mui/lab";
import { Button, IconButton, useMediaQuery } from "@mui/material";
import { Box, Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export default function CustomPagination({
  pageNum,
  totalPages,
  search = null,
  category,
  topic,
}) {
  const mobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const navigate = useNavigate();

  //Pagination state
  const [thePage, setThePage] = useState(pageNum);
  useEffect(() => {
    setThePage(pageNum);
  }, [pageNum]);

  //Build the pagination array
  const { items } = usePagination({
    count: totalPages,
    page: thePage,
    onChange: (event, value) => {
      setThePage(value);
    },
    siblingCount: mobile ? 0 : 1,
  });

  //Format the pagination URL
  const location = useLocation();

  const getTo = (category, topic, pageNum) => {
    let url;
    if (pageNum === 0) {
      if (category?.slug && topic?.slug) {
        url = `/insights/category/${category?.slug}/?topic=${topic?.slug}`;
      } else if (category?.slug && !topic?.slug) {
        url = `/insights/category/${category?.slug}/`;
      } else if (!category?.slug && topic?.slug) {
        url = `/insights/?topic=${topic?.slug}`;
      } else {
        url = `/insights/`;
      }
    } else {
      if (category?.slug && topic?.slug) {
        url = `/insights/category/${category?.slug}/page/${pageNum}/?topic=${topic?.slug}`;
      } else if (category?.slug && !topic?.slug) {
        url = `/insights/category/page/${pageNum}/${category?.slug}/`;
      } else if (!category?.slug && topic?.slug) {
        url = `/insights/page/${pageNum}/?topic=${topic?.slug}`;
      } else {
        url = `/insights/page/${pageNum}/`;
      }
    }
    return url;
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          mt: "2rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        {items.map(({ page, type, selected, ...item }, index) => {
          //Ellipsis
          if (type === "start-ellipsis" || type === "end-ellipsis") {
            return (
              <Box
                sx={{
                  m: "0 0.5rem 0.5rem 0.5rem",
                  fontSize: "1rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                key={index}
              >
                ...
              </Box>
            );
          }
          //Page buttons
          else if (type === "page") {
            return (
              <Button
                disabled={page === pageNum}
                component={RouterLink}
                to={getTo(category, topic, page)}
                sx={{
                  m: "0.5rem",
                  p: "0.25rem",
                  borderRadius: "50%",
                  minWidth: "0 !important",
                  minHeight: "0 !important",
                  width: "40px",
                  aspectRatio: 1,
                  fontSize: "1rem",
                  fontWeight: 600,
                  background: selected ? "#eaeaea" : "none",
                  color: "#6c6c6c",
                }}
                key={index}
              >
                {page}
              </Button>
            );
          }
          //Prev / next buttons
          else {
            return (
              <IconButton
                {...item}
                component={RouterLink}
                to={getTo(page)}
                sx={{
                  m: "0.5rem",
                  p: "0.25rem",
                }}
                key={index}
              >
                {type === "previous" ? (
                  <ChevronLeftIcon />
                ) : (
                  <ChevronRightIcon />
                )}
              </IconButton>
            );
          }
        })}
      </Box>
    </Container>
  );
}
